// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue                  from 'vue'
import App                  from './App'
import VueRouter            from "vue-router"
import router               from './router'
import axios                from 'axios'
import VueTheMask           from 'vue-the-mask'
import VueMoney             from 'v-money'
import mobile               from 'mobile-device-detect';
import Autocomplete         from '@trevoreyre/autocomplete-vue'
import iosAlertView         from 'vue-ios-alertview';
import '@trevoreyre/autocomplete-vue/dist/style.css'
// var url                     = "http://localhost:8081";
// var url                     = "https://app.landin.com.br";
var url                     = "http://landin.negociar.org";
Vue.use(VueRouter)
Vue.use(VueTheMask)
Vue.use(VueMoney)
Vue.use(mobile)
Vue.use(iosAlertView)
Vue.use(Autocomplete)
window.axios                = axios
axios.defaults.baseURL      = url;
Vue.config.productionTip    = false
window._app;

var cleanObject             = function(obj) {
    Object.keys(obj).reduce(function (obj, key) {

      if (obj["_" +  key] === obj[key]) {
        delete obj["_" +  key];
      }
      return obj;

    }, obj);    
    return JSON.sort(obj);
}

function isObject(v) {
    return '[object Object]' === Object.prototype.toString.call(v);
};

JSON.sort = function(o) {
if (Array.isArray(o)) {
        return o.sort().map(JSON.sort);
    } else if (isObject(o)) {
        return Object
            .keys(o)
        .sort()
            .reduce(function(a, k) {
                a[k] = JSON.sort(o[k]);

                return a;
            }, {});
    }

    return o;
}

if (!window.cordova && location.hostname != "localhost") {
    window.console.log      = function(){};
}
if (window.cordova || location.hostname != "localhost") {
    axios.defaults.timeout  = 40000;
    // axios.defaults.timeout  = 15000;
}

axios.interceptors.request.use(function (config) {
    var self = this;
    return new Promise((resolve, reject) => {
        // console.log("interceptors antes", self, config);

        // if (config.db && !window.__app.internet.online) {
        //     window.__app.db[config.db].get(md5(JSON.stringify(config.data || config.params))).then(function (result) {
        //         console.log("getDB result", result);
                
        //         resolve(result);
        //     }).catch(function (err) {
        //         console.log("getDB err", err);
        //         reject(err);
        //     });

        // } else {
            resolve(config);  
        // }

    });
}, function (error) {
    return Promise.reject(error);
});

// // Add a response interceptor
axios.interceptors.response.use(function (response) {
    return new Promise((resolve, reject) => {
        console.log("interceptors depois", response);
        if (response.config.db) {

            if (response.config.data) {
                delete response.config.data.__ob__;
            }
            if (response.config.params) {
                delete response.config.params.__ob__;
            }

            var str         = JSON.stringify(response.config.data ? cleanObject(response.config.data) : cleanObject(response.config.params));
            console.log("STR HASH", str)
            var hashUnico = md5(str);
            console.log("HASH UNICO SALVAR", response.config.url, hashUnico, response.config.data, response.config.params)

            window.__app.salvarDB(response.config.db, (response.config.data ? cleanObject(response.config.data) : cleanObject(response.config.params)), response.data, hashUnico).then(function(result) {
                resolve(response);
            }).catch(function(error) {
                reject(error);
            });
        } else {
            resolve(response);
        }
    });
}, function (error) {
    return new Promise((resolve, reject) => {

        console.log("interceptors ERRO:", error.config, error.status, error.statusCode, error.message);
        // if (error.message == "Network Error" && error.config.db) {
        if (!error.status && error.config.db) {
            if (error.config.data) {
                delete error.config.data.__ob__;
            }
            if (error.config.params) {
                delete error.config.params.__ob__;
            }
            var str         = JSON.stringify(error.config.data ? cleanObject(error.config.data) : cleanObject(error.config.params));
            console.log("STR HASH", str)
            var hashUnico   = md5(str);

            console.log("HASH UNICO", error.config.url, hashUnico, error.config.data, error.config.params)

            window.__app.db[error.config.db].get(hashUnico).then(function (result) {
                console.log("getDB result", result);
                error.data = result.result;
                resolve(error);
            }).catch(function (err) {
                console.log("getDB err", error.config.url, err);
                reject(error);
            });         
        } else {
            reject(error);
        }

    });
    // return Promise.reject(error);
});



/* eslint-disable no-new */
new Vue({
  	el:                  '#app',
  	router,
  	components: {
        App
    },
  	template:            '<App/>',

    data: {
        "logged":       false,
        "cordova":      window.cordova || null,
        "user":  {
            "_cod":     null,
            "_token":   null,
        },
        "db":           null,
        "mobile":       mobile,
        "internet":      {
            "online":   true  
        },
        "tmp":  {
            "estoque": {
                "tab": ""
            }
        },
        "config": {
            "url":      url,
            "googleAnalytics": {
                "id":   "G-F9RQYFMT25"
            },
            "pusher": {
                "key": "5c9dc4d18e0cfe86de70"
            },
            "money": {
                "decimal":            ',',
                "thousands":          '.',
                "prefix":             '',
                "suffix":             '',
                "precision":          2,
                "masked":             false
            },
            "dbs": [
                {
                    "nome":  "chat",
                    "index": {
                        "fields": []
                    }
                },
                {
                    "nome":  "chatMensagens",
                    "index": {
                        "fields": []
                    }
                },
                {
                    "nome":  "chatUsuarios",
                    "index": {
                        "fields": []
                    }
                },                                
                {
                    "nome":  "estoque",
                    "index": {
                        "fields": []
                    }
                },
                {
                    "nome":  "estoqueHistorico",
                    "index": {
                        "fields": []
                    }
                },
                {
                    "nome":  "estoqueArmazenamento",
                    "index": {
                        "fields": []
                    }
                },                                
                {
                    "nome":  "logs",
                    "index": {
                        "fields": []
                    }
                },
                {
                    "nome":  "alertas",
                    "index": {
                        "fields": []
                    }
                },
                {
                    "nome":  "notificacoes",
                    "index": {
                        "fields": []
                    }
                },                
                {
                    "nome":  "pedidos",
                    "index": {
                        "fields": []
                    }
                },
                {
                    "nome":  "pedidosRascunho",
                    "index": {
                        "fields": []
                    }
                },                                      
                {
                    "nome":  "arquivos",
                    "index": {
                        "fields": []
                    }
                },  
                {
                    "nome":  "agendamentos",
                    "index": {
                        "fields": []
                    }
                },  
                {
                    "nome":  "premios",
                    "index": {
                        "fields": []
                    }
                },     
                {
                    "nome":  "metricas",
                    "index": {
                        "fields": []
                    }
                },                
                {
                    "nome":  "pedidosDashboard",
                    "index": {
                        "fields": []
                    }
                },
                {
                    "nome":  "pedidosPendentes",
                    "index": {
                        "fields": []
                    }
                },
                {
                    "nome":  "estoqueHistorico",
                    "index": {
                        "fields": []
                    }
                },                
                {
                    "nome":  "precosEspeciais",
                    "index": {
                        "fields": []
                    }
                },
                {
                    "nome":  "catalogo",
                    "index": {
                        "fields": []
                    }
                },
                {
                    "nome":  "clientes",
                    "index": {
                        "fields": []
                    }
                },
                {
                    "nome":  "empresas",
                    "index": {
                        "fields": []
                    }
                }, 
                {
                    "nome":  "avaliacoes",
                    "index": {
                        "fields": []
                    }
                },                   
                {
                    "nome":  "usuarios",
                    "index": {
                        "fields": []
                    }
                },                                                
            ],            
            "pedidoStatus": {
                "-1": {
                    "class": "color-red",
                    "text": "Cancelado",
                },
                "0": {
                    "class": "color-orange",
                    "text": "Aguardando confirmação",
                },
                "1": {
                    "class": "color-blue",
                    "text": "Agendado",
                },
                "2": {
                    "class": "color-green",
                    "text": "Realizado",
                },                
            }        
        }
    },
    methods: {
        initialize: function() {
            console.log("app.initialize()");
            var self = this;

            gtag('js', new Date());
            gtag('config', self.config.googleAnalytics.id);

            window.confirmWeb   = window.confirm;
            window.confirm      = function(msg, callback) {
                if (window.confirmWeb(msg)) {
                    callback();
                }
            }

            var self        = this;
            window.__app    = self;
            document.addEventListener('deviceready', this.onDeviceReady.bind(this), false);
            var login       = self.checkLogin();
            self.fixClass();
            // console.log("checkLogin()", window.history.length, login)

        },
        onOnline: function() {
            console.log("onOnline()", window.navigator.connection);
            var self            = this;
            var networkState    = window.navigator.connection.type;

            if (networkState !== Connection.NONE) {
                self.internet.online = true;
            } else {
                self.internet.online = false;
            }
        },
        onOffline: function() {
            console.log("onOffline()");
            var self                = this;
            self.internet.online    = false;
        },
        scrollTop: function() {
            console.log("scrollTop()")
            setTimeout(function() {
                $(".dashboard-content-inner")[0].scrollTo({
                    top:            0
                });     
            }, 100);
        },         
        atualizarPushToken: function() {
            console.log("push > atualizarPushToken()")
            var self = this;
            if (self.logged && window.localStorage.pushToken) {
                axios.post("api/push-notification.php", {
                    "_cod":         self.user.cod,
                    "_token":       self.user.token,
                    "dispositivo":  self.mobile.osName,
                    "pushToken":    localStorage.getItem('pushToken')
                })
                .then(response => {
                    window.localStorage.setItem("pushTokenSalvo", new Date());
                    console.log("push > Salvou push", response)
                })
                .catch(error => {
                    console.log("push > Erro:", error)
                });                 
            }                
        },
        checkPushNotificationPermission: function(requested){
            var self = this;
            window.FirebasePlugin.hasPermission(function(hasPermission){
                if(hasPermission){
                    console.log("push > Remote notifications permission granted");
                    self.getPushNotificationToken();
                }else if(!requested){
                    console.log("push > Requesting remote notifications permission");
                    window.FirebasePlugin.grantPermission(self.checkPushNotificationPermission.bind(this, true));
                }else{
                    console.log("push > Notifications won't be shown as permission is denied");
                }
            });
        },    
        syncInfosDB: function() {
            console.log("syncInfosDB()");
            var self = this;

            var getUsuarios = function() {
                console.log("getUsuarios()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "usuarios",                    
                        "params": {
                            "all":          true,
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "tipo":         "contratante",
                        }
                    };

                    axios.get("api/usuarios.php", form)
                    .then(response => {
                        
                        console.log("getUsuarios() ok", response)
                        resolve(response.data.result.itens);
      
                    })
                    .catch(error => {
                        console.log("getUsuarios() error", error)
                        resolve(error);
                    });   
                });  
            };

            var getUsuarios2 = function() {
                console.log("getUsuarios2()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "usuarios",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "tipo":         "contratante",
                            "pesquisa":     "",
                            "page":         1
                        }
                    };

                    axios.get("api/usuarios.php", form)
                    .then(response => {
                        
                        console.log("getUsuarios2() ok", response)
                        resolve(response.data.result.itens);
      
                    })
                    .catch(error => {
                        console.log("getUsuarios2() error", error)
                        resolve(error);
                    });   
                });  
            };            

            var getUsuarios3 = function() {
                console.log("getUsuarios3()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "usuarios",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "tipo":         "admin,prestador,gerencial",
                            "pesquisa":     "",
                            "page":         1
                        }
                    };

                    axios.get("api/usuarios.php", form)
                    .then(response => {
                        
                        console.log("getUsuarios3() ok", response)
                        resolve(response.data.result.itens);
      
                    })
                    .catch(error => {
                        console.log("getUsuarios3() error", error)
                        resolve(error);
                    });   
                });  
            };            


            var getClientes = function() {
                console.log("getClientes()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "clientes",
                        "params": {
                            "all":          true,
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token
                            // "page":         1,
                            // "autocomplete": true,
                            // "pesquisa":     ""
                        },
                    };

                    axios.get("api/clientes.php", form)
                    .then(response => {
                        
                        console.log("getClientes() ok", response)
                        resolve(response.data.result.itens);
      
                    })
                    .catch(error => {
                        console.log("getClientes() error", error)
                        
                        resolve(error);
                    });   
                });  
            };

            var getClientes2 = function() {
                console.log("getClientes2()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "clientes",
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "page":         1,
                            "pesquisa":     ""
                        },
                    };

                    axios.get("api/clientes.php", form)
                    .then(response => {
                        
                        console.log("getClientes2() ok", response)
                        resolve(response.data.result.itens);
      
                    })
                    .catch(error => {
                        console.log("getClientes2() error", error)
                        
                        resolve(error);
                    });   
                });  
            };            

            var getEmpresas = function() {
                console.log("getEmpresas()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "empresas",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token
                        }
                    };

                    axios.get("api/empresas.php", form)
                    .then(response => {
                        
                        console.log("getEmpresas() ok", response)
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("getEmpresas() error", error)
                        resolve(error);
                    });   
                });                 
            };

            var getEmpresas2 = function() {
                console.log("getEmpresas2()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "empresas",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "pesquisa":     ""
                        }
                    };

                    axios.get("api/empresas.php", form)
                    .then(response => {
                        
                        console.log("getEmpresas2() ok", response)
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("getEmpresas2() error", error)
                        resolve(error);
                    });   
                });                 
            };            

            var getVendas = function() {
                console.log("getVendas()");
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "pedidos",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "tipo":         "venda",
                            "filtro":       "finalizados",
                            "dataInicio":   "",
                            "dataFinal":    "",                            
                            "empresaCod":   ""                            
                        }
                    };

                    axios.get("api/pedidos.php", form)
                    .then(response => {
                        
                        console.log("getVendas() ok", response)
                        resolve(response.data.result);

                    })
                    .catch(error => {

                        console.log("getVendas() error", error)
                        resolve(error);                   
                    });   
                });  
            };

            var getAbastecimentos = function() {
                console.log("getAbastecimentos()");
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "pedidos",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "tipo":         "agendamento",
                            "filtro":       "finalizados",
                            "empresaCod":   "",
                            "dataInicio":   "",
                            "dataFinal":    "",                            
                        }
                    };

                    axios.get("api/pedidos.php", form)
                    .then(response => {
                        
                        console.log("getAbastecimentos() ok", response)
                        resolve(response.data.result);

                    })
                    .catch(error => {

                        console.log("getAbastecimentos() error", error)
                        resolve(error);                   
                    });   
                });  
            };            

            var getAgendamentos = function() {
                console.log("getAgendamentos()");
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "agendamentos",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "tipo":         "agendamento",
                            "filtro":       "pendentes",
                            "page":         1,
                            "empresaCod":   ""
                        }
                    };

                    axios.get("api/pedidos.php", form)
                    .then(response => {
                        
                        console.log("getAgendamentos() ok", response)
                        resolve(response.data.result);

                    })
                    .catch(error => {

                        console.log("getAgendamentos() error", error)
                        resolve(error);                   
                    });   
                });  
            };            


            var getEstoque = function() {
                console.log("getEstoque()");
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "estoque",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "group":        false
                        }
                    };

                    axios.get("api/estoque.php", form)
                    .then(response => {
                        
                        console.log("getEstoque() ok", response)
                        resolve(response.data.result);

                    })
                    .catch(error => {

                        console.log("getEstoque() error", error)
                        resolve(error);                   
                    });   
                });  
            };

            var getEstoque2 = function() {
                console.log("getEstoque2()");
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "estoque",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "empresaCod":   (self.$root.user.empresaCod ? self.$root.user.empresaCod : "")
                        }
                    };

                    axios.get("api/estoque.php", form)
                    .then(response => {
                        
                        console.log("getEstoque2() ok", response)
                        resolve(response.data.result);

                    })
                    .catch(error => {

                        console.log("getEstoque2() error", error)
                        resolve(error);                   
                    });   
                });  
            };


            var getEstoqueHistorico = function() {
                console.log("getEstoqueHistorico()");
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "estoqueHistorico",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "tipo":         "historico",
                            "empresaCod":   (self.$root.user.empresaCod ? self.$root.user.empresaCod : "")                     
                        }
                    };

                    axios.get("api/estoque.php", form)
                    .then(response => {
                        
                        console.log("getEstoqueHistorico() ok", response)
                        resolve(response.data.result);

                    })
                    .catch(error => {

                        console.log("getEstoqueHistorico() error", error)
                        resolve(error);                   
                    });   
                });  
            };

            var getEstoqueMedicao = function() {
                console.log("getEstoqueMedicao()");
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "estoque",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "tipo":         "medicao",
                            // "empresaCod":   (self.$root.user.empresaCod ? self.$root.user.empresaCod : "")                     
                        }
                    };

                    axios.get("api/estoque.php", form)
                    .then(response => {
                        
                        console.log("getEstoqueMedicao() ok", response)
                        resolve(response.data.result);

                    })
                    .catch(error => {

                        console.log("getEstoqueMedicao() error", error)
                        resolve(error);                   
                    });   
                });  
            };                        

            var getLogs = function() {
                console.log("getLogs()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "logs",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "page":             1,
                            "pesquisa":         "",
                            "dataInicio":       "",
                            "dataFinal":        "",
                            "tipo":             ""
                        }
                    };

                    axios.get("api/logs.php", form)
                    .then(response => {
                        
                        console.log("getLogs() ok", response)
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("getLogs() error", error)
                        resolve(error);
                  
                    });   
                });
            };

            var getAvaliacoes = function() {
                console.log("getAvaliacoes()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "avaliacoes",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token
                        }
                    };

                    axios.get("api/avaliacoes.php", form)
                    .then(response => {
                        
                        console.log("getAvaliacoes() ok", response)
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("getAvaliacoes() error", error)
                        resolve(error);
                  
                    });   
                });
            };            

            var getCatalogo = function() {
                console.log("getCatalogo()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "catalogo",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "tipo":         "catalogo",
                            "ordem":        "id ASC"
                        }
                    };

                    axios.get("api/catalogo.php", form)
                    .then(response => {
                        
                        console.log("getCatalogo() ok", response)
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("getCatalogo() error", error)
                        resolve(error);
                  
                    });   
                });
            };

            var getCatalogo2 = function() {
                console.log("getCatalogo2()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "catalogo",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "tipo":         "catalogo"
                        }
                    };

                    axios.get("api/catalogo.php", form)
                    .then(response => {
                        
                        console.log("getCatalogo2() ok", response)
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("getCatalogo2() error", error)
                        resolve(error);
                  
                    });   
                });
            };            

            var getPremios = function() {
                console.log("getPremios()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "catalogo",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "tipo":         "premio"
                        }
                    };

                    axios.get("api/catalogo.php", form)
                    .then(response => {
                        
                        console.log("getPremios() ok", response)
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("getPremios() error", error)
                        resolve(error);
                  
                    });   
                });
            };            

            var getPrecosEspeciais = function() {
                console.log("getPrecosEspeciais()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "precosEspeciais",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "mes":          (new Date().getMonth()+1),
                            "ano":          (new Date().getFullYear()),
                            "group":        false
                        }
                    };

                    axios.get("api/precos-especiais-v2.php", form)
                    .then(response => {
                        
                        console.log("getPrecosEspeciais() ok", response)
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("getPrecosEspeciais() error", error)
                        resolve(error);
                                          
                    });   
                }); 
            };

            var getPrecosEspeciais2 = function() {
                console.log("getPrecosEspeciais2()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "precosEspeciais",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "mes":          (new Date().getMonth()+1),
                            "ano":          (new Date().getFullYear())
                        }
                    };

                    axios.get("api/precos-especiais-v2.php", form)
                    .then(response => {
                        
                        console.log("getPrecosEspeciais2() ok", response)
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("getPrecosEspeciais2() error", error)
                        resolve(error);
                                          
                    });   
                }); 
            };            

            var getAlertas = function() {
                console.log("getAlertas()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "alertas",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token,
                            "page":         1
                        }
                    };

                    axios.get("api/alertas.php", form)
                    .then(response => {
                        
                        console.log("getAlertas() ok", response)
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("getAlertas() error", error)
                        resolve(error);
                                          
                    });   
                }); 
            }; 

            var getNotificacoes = function() {
                console.log("getNotificacoes()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "notificacoes",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token
                        }
                    };

                    axios.get("api/notificacoes.php", form)
                    .then(response => {
                        
                        console.log("getNotificacoes() ok", response)
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("getNotificacoes() error", error)
                        resolve(error);
                                          
                    });   
                }); 
            };

            var getArquivos = function() {
                console.log("getArquivos()")
                return new Promise(function(resolve, reject) {

                    var form = {
                        "db":               "arquivos",                    
                        "params": {
                            "_cod":         self.user.cod, 
                            "_token":       self.user.token
                        }
                    };

                    axios.get("api/arquivos.php", form)
                    .then(response => {
                        
                        console.log("getArquivos() ok", response)
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("getArquivos() error", error)
                        resolve(error);
                                          
                    });   
                }); 
            };               


            Promise.resolve()
            .then(getUsuarios())
            .then(getUsuarios2())
            .then(getClientes())
            .then(getClientes2())
            .then(getEmpresas())
            .then(getEmpresas2())
            .then(getVendas())
            .then(getAbastecimentos())
            .then(getAgendamentos())
            .then(getEstoque())
            .then(getEstoqueHistorico())
            .then(getLogs())
            .then(getAvaliacoes())
            .then(getCatalogo())
            .then(getPremios())
            .then(getPrecosEspeciais())
            .then(getPrecosEspeciais2())
            .then(getEstoqueMedicao())
            .then(getAlertas())
            .then(getNotificacoes())
            .then(getArquivos())
            .then(getEstoque2())
            .then(getCatalogo2())
            .then(function() {
                console.log("syncInfosDB ok")
            }).catch(function(error) {
                console.log("syncInfosDB error")

            });
        },
        getPushNotificationToken: function(){
            var self = this;
            window.FirebasePlugin.getToken(function(token){
                console.log("push > Got FCM token: " + token);
                localStorage.setItem('pushToken', token);
                self.atualizarPushToken();
            }, function(error) {
                console.log("push > Failed to get FCM token", error);
            });
        },     
        go: function(route, data) {
            console.log("app.go()", route, data)
            var self = this;
            // iframe.src = route;

            if (!data) {
                data = {};
            } else {
                data = JSON.parse(data);
                console.log("fez parse", data);
            }
            self.$router.push({ 
                name:       route,
                query:      data
            }).catch(()=>{});               
            $("body .overhang").fadeOut(500);
        },
        redirect: function(route) {
            console.log("app.redirect()", route)
            var self = this;
            self.$router.push({ 
                path:       route
            }).catch(()=>{});               
            $("body .overhang").fadeOut(500);
        },                  
        onPushNotification: function(message) {
            console.log("push > onPushNotification()", message);
            var self        = this;

            if (self.mobile.osName == "iOS") {
                if (message.messageType == "notification" && message.aps) {
                    if (message.aps.alert) {
                        message.title   = message.aps.alert.title;
                        message.body    = message.aps.alert.body;
                    }
                }
            }

            if (message.messageType == "notification" && message.tap && message.link) {
                window.open(message.link, "_system");
                return false;
            }

            if (message.messageType == "notification" && message.tap && message.route) {
                self.go(message.route, message.query || null);
            }

            if (message.messageType == "notification" && message.title && message.body) {

                if (message.route) {
                    if (message.route == self.$route.name) {
                        console.log("esta na mesma pagina, nao mostra push")
                        return false;
                    }
                }

                window.ultimoPush   = message;
                var link = "";
                if (message.route) {
                    link = "onclick='window.__app.go(\"" + message.route + "\", window.ultimoPush.query)'";
                } else if (message.link) {
                    link = "onclick='window.open(\"" + message.link + "\", \"_system\")'";
                }

                navigator.vibrate(1000); 
                navigator.notification.beep(1);

                $("body").overhang({
                    custom: true,
                    primary: "#FFFFFF",
                    accent: "#FFFFFF",
                    textColor: "#333333",
                    html: true,
                    message: "<a " + link + "><h4>" + message.title + "</h4><p>" + message.body + "</p></a>",
                    closeConfirm: "true",
                    customClasses: "push-notification",
                    callback: function (selection) {
                        console.log("callback notification", selection)
                        // if (message.route) {
                            
                            // iframe.src  = message.route;
                        // }
                    }
                });

            }

        },               
        onDeviceReady: function() {
            console.log("onDeviceReady()")
            var self    = this;

            if (!self.db) {
                self.initDB();
            }

            document.addEventListener('online', this.onOnline.bind(this), false);
            document.addEventListener('offline', this.onOffline.bind(this), false);

            window.__onResume = function() {
                console.log("onResume");
                if (window.__app.$route.name == "Dashboard") {
                    if (window.__resume) window.__resume();
                }
            }
            document.removeEventListener("resume", window.__onResume, false);
            document.addEventListener("resume", window.__onResume, false);

            window.open = cordova.InAppBrowser.open;

            if (self.mobile.isTablet) {
                console.log("É tablet, deixa a orientation livre");
                window.screen.orientation.lock(window.screen.orientation.type);
                window.screen.orientation.unlock();
            } else {
                window.screen.orientation.lock("portrait");
            }

            self.checkPushNotificationPermission();

            window.FirebasePlugin.onMessageReceived(function(message) {
                console.log("push > onMessageReceived", message);
                try {
                    console.log(message);
                    self.onPushNotification(message);
                } catch(e) {
                    console.log("push > Exception in onMessageReceived callback: "+e.message);
                }

            }, function(error) {
                console.log("push > Failed receiving window.FirebasePlugin message", error);
            });

            window.FirebasePlugin.onTokenRefresh(function(token){
                console.log("push > Token refreshed: " + token)
                window.localStorage.setItem("pushToken", token);

            }, function(error) {
                console.log("push > Failed to refresh token", error);
            });


            self.backbutton = function(e){
                console.log("backbutton", e)
                e.preventDefault();
                self.back();
                return false;
            }

            document.addEventListener('backbutton', self.backbutton, false); 

            window.alert      = function(msg){
                navigator.notification.alert(msg, function(){}, "", "Ok");
            };

            window.confirm    = function(msg, callback){
                navigator.notification.confirm(msg, function(i) {
                    if (i == 1) {
                        callback();
                    }
                }, "", ['Sim', 'Cancelar']);
            };
            
        },
        setUser: function(usuario) {
            var self    = this;
            return new Promise(function(resolve, reject) {
                window.localStorage.setItem("_usuario", JSON.stringify(usuario));
                self.logged    = true;
                self.user   = usuario;
                resolve(usuario);

            });
        },
        getUser: function(force) {
            var self        = this;
            console.log("getUser()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.user.cod, 
                        "_token":       self.user.token
                    }
                };

                axios.get("api/usuarios.php", form)
                .then(response => {
                    
                    console.log("getUser() response", response);
                    self.setUser(response.data.result);
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getUser() error", error);
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.logout();
                        }
                    }
                    
                    reject(error);
                    
                });   
            });   
        },          
        checkLogin: function() {
            var self    = this;
            if (!window.localStorage.getItem("_usuario")) {
                return false;
            } else {
                var usuario = null;
                try {
                    usuario = JSON.parse(window.localStorage.getItem("_usuario"));
                    self.setUser(usuario);
                    self.getUser();
                    return true;
                } catch(err) {
                    console.log("checkLogin() error parse", err);
                    return false;
                }
            }
        },
        logout: function() {
            var self = this;
        	loading.show();
        	window.localStorage.clear();
            Promise.all(Object.keys(self.db).map(function(item) {
                return new Promise(function(resolve, reject) {
                    self.db[item].destroy().then(function () {
                        // console.log("db:", item, "apagada com sucesso");
                        resolve(true);
                    }).catch(function (err) {
                        // console.log("db:", item, "erro ao apagar", err);
                        resolve(false);
                    });            
                });
            })).then(function() {
        	   // console.log("logout ok");
               location.reload();
            }).catch(function(err) {
               // console.log("logout err", err);
               location.reload();
            });
        },
        back: function() {
            var self = this;
            console.log("back()", self, window.history.length);
            if (window.history.length > 3) {
                $(".content-load .dashboard-container").fadeOut(100);                
            }

            if (self.$route.meta.auth == false) {
                window.history.go(-3);
            } else {
                window.history.back();
            }

        },
        fixClass: function() {
            var self = this;
            if (self.$route) {
                $("body").attr("class", "");
                $("body").addClass("current-page-" + self.$route.name.toLowerCase());            
            }
        },
        addEvents: function() {
            var self = this;
            $("body").on("click", "a[target='_blank']", function(e) {
                console.log("open InAppBrowser", e.currentTarget.href, e);
                if (window.cordova) {
                    e.preventDefault();
                    window.open = cordova.InAppBrowser.open;
                    window.open(e.currentTarget.href, "_system");
                }

            });            
        },
        initDB: function() {
            console.log("initDB()", window.cordova);
            var self        = this;
            self.db         = {};
            var dbs         = self.config.dbs;
            var options     = {};

            if (!window.cordova) {
            } else {
                options     = {adapter: 'cordova-sqlite', location: "default"};
            }
                    
            var c = 0;
            dbs.forEach(function(item) {

                self.db[item.nome]     = new PouchDB(item.nome + '.db', options);

                // self.db[item.nome].createIndex({
                //     index:              item.index
                // }).then(function (result) {
                //     // console.log("db.", item.nome ,"createIndex() result", result);
                //     self.$forceUpdate();
                // }).catch(function (err) {
                //     console.log("db.", item.nome ,"createIndex() err", err);
                // });
                c++;
                if (c == (dbs.length)) {
                    // console.log("Criou todas as dbs", self.db)
                    self.$emit("initDB", self.db);
                    // self.$app.emit('initDB', self.db);
                }

            });
        },
        // getDB: function(db, filtro) {
        //     console.log("getDB()", db, filtro)
        //     var self = this;
        //     return new Promise(function(resolve, reject) {

        //         if (!filtro) {
        //             filtro  = {};
        //         }

        //         // {
        //         //     selector: {
        //         //         $and: [
        //         //             {
        //         //                 $or: [
        //         //                     {"tipo": "aluguel"},
        //         //                     {"tipo": "venda"}
        //         //                 ],
        //         //             },
        //         //             {
        //         //                 "status": {
        //         //                     $eq: "1"
        //         //                 }
        //         //             }
        //         //         ]
        //         //     },
        //         //     limit: 999                    
        //         // }                

        //         self.db[db].find(filtro).then(function (result) {
                    
        //             console.log("getDB result", db, filtro, "\n:::", result);
        //             var list    = JSON.parse(JSON.stringify(result.docs));
        //             // list.sort((a, b) => (parseFloat(a.id) > parseFloat(b.id)) ? -1 : 1);
                   
        //             resolve(list);

        //             // self.order();

        //         }).catch(function (err) {
        //             console.log("getDB err", err);
        //             reject(err);
        //         });                
        //     });                
        // },        
        salvarDB: function(db, request, itens, cod) {
            var self        = this;
            return new Promise(function(resolve, reject) {
                console.log("salvarDB()", db, itens);
                var docs        = [];
                if (!cod) {
                    var _id         = md5(JSON.stringify(request));
                } else {
                    var _id         = cod;
                }
                var obj         = false;

                console.log("_ID", _id);

                self.$root.db[db].get(_id).then(function (doc) {
                    return new Promise(function(resolve, reject) {
                        console.log("Existe doc?", doc)
                        obj         = doc;
                        obj.result  = itens;
                        obj.request = request;

                        self.$root.db[db].post(obj).then(function(res) {
                            // console.log("Sucesso ao fazer post", res)
                            resolve(obj);
                        }).catch(function(error) {
                            // console.log("Erro ao fazer post", error)
                            reject(error);
                        });
                    });
                }).catch(function(error) {
                    return new Promise(function(resolve, reject) {
                        console.log("Erro ao buscar doc", error);
                        if (error.status == 404) {
                            var obj         = {
                                "_id":      _id,
                                "request":  request,
                                "result":   itens
                            };

                            docs.push(obj);

                            self.db[db].bulkDocs(docs).then(function (result) {
                                console.log("salvarDB()", db, "ok:", result);
                                resolve(result);
                            }).catch(function (err) {
                                console.log("salvarDB()", db, "erro:", err);
                                reject(err);
                            }); 
                        } else {
                            reject(error);
                        }
                    });
                }).then(function(result) {
                    console.log("Fim", result);
                    resolve(result);
                }).catch(function(error) {
                    console.log("Erro novamente", error)
                    reject(error);
                });
            });   
        },               
    },
    created: function() {
    	console.log("APP created")
    	var self = this;
        self.initialize();
        if (!self.db && !window.cordova) {
            self.initDB();
        }
    	if (window.__usuario) {
    		self.setUser(window.__usuario);
        }
        self.addEvents();
    },
	watch:{
	    "internet.online": function(val) {
            console.log("change internet online", val);
            if (val) {
                $(".internet-offline").hide();
            } else {
                $(".internet-offline").show();
            }
        },
        $route (to, from){
	        var self = this;
            self.fixClass();
	        setTimeout(function() {
	        	window.fixHeight();
                window.scrollTo({
                    top: 0
                });
                window.mmenuInit();
                gtag('config', self.config.googleAnalytics.id, {'page_title': to.meta.title});                 

	        }, 100);
	    }
	},
    on: {
        
    }      	
})



// WEBPACK FOOTER //
// ./src/main.js